export function LocalOnlyPage() {
  return (
    <div className="mx-auto max-w-xl px-6 py-16 text-slate-800">
      <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">EWP AI</p>
      <h1 className="mt-2 text-2xl font-semibold">Labeling is local only</h1>
      <p className="mt-3 text-sm leading-6 text-slate-600">
        Cloud labeling is off. Reviews no longer save to D1. On this PC, run the Desktop labeler and
        write to <code className="rounded bg-slate-100 px-1">local/data/labels.json</code>.
      </p>
      <pre className="mt-6 overflow-x-auto rounded-lg bg-slate-900 p-4 text-sm text-slate-100">
        {`cd C:\\Users\\scott\\Desktop\\ewp-ai
.\\label.ps1`}
      </pre>
      <p className="mt-4 text-sm text-slate-600">
        That opens <code className="rounded bg-slate-100 px-1">http://127.0.0.1:5175/label?pack=label-all</code>
        . No login. The cloud reviews already pulled onto this machine are in that file.
      </p>
    </div>
  );
}
